import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import ar from "vuetify/es5/locale/ar";
import {
  VApp,
  VMain,
  VParallax,
  VLayout,
  VAppBar,
  VAppBarTitle,
  VAppBarNavIcon,
  VSpacer,
  VTabs,
  VTab,
  VFabTransition,
  VContainer,
  VIcon,
  VList,
  VListItem,
  VListItemIcon,
  VListItemTitle,
  VListItemContent,
  VListItemAction,
  VListItemAvatar,
  VCheckbox,
  VTooltip,
  VSlider,
  VSnackbar,
  VRow,
  VCol,
  VCard,
  VCardTitle,
  VCardText,
  VCardSubtitle,
  VCardActions,
  VDialog,
  VBtn,
  VBottomNavigation,
  VFooter,
  VSkeletonLoader,
  VTextField,
  VProgressCircular,
  VPagination,
  VCarousel,
  VCarouselItem,
} from "vuetify/lib/components";

// srtyles
import "@fortawesome/fontawesome-free/css/all.css";
import "@/assets/main.scss";

// import vuetify colors
import colors from "vuetify/es5/util/colors";

Vue.use(Vuetify, {
  components: {
    VApp,
    VMain,
    VParallax,
    VLayout,
    VAppBar,
    VAppBarTitle,
    VAppBarNavIcon,
    VSpacer,
    VTabs,
    VTab,
    VFabTransition,
    VIcon,
    VList,
    VListItem,
    VListItemIcon,
    VListItemTitle,
    VListItemContent,
    VListItemAction,
    VListItemAvatar,
    VCheckbox,
    VTooltip,
    VSlider,
    VSnackbar,
    VRow,
    VCol,
    VCard,
    VCardTitle,
    VCardText,
    VCardSubtitle,
    VCardActions,
    VDialog,
    VBtn,
    VBottomNavigation,
    VFooter,
    VSkeletonLoader,
    VContainer,
    VTextField,
    VProgressCircular,
    VPagination,
    VCarousel,
    VCarouselItem,
  },
});

// set global shared colors palette
export const globalColorsPalette = {
  primary: colors.green.darken2,
  secondary: colors.green.base,
  error: colors.red.darken2,
  info: colors.green.lighten1,
  success: colors.green.accent4,
  warning: colors.yellow.darken3,
};

// export Vuetify instance
export default new Vuetify({
  treeShake: true,
  rtl: true,
  theme: {
    dark: process.env.NODE_ENV === "development",
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        ...globalColorsPalette,
        bg: colors.grey.lighten3,
      },
      dark: {
        ...globalColorsPalette,
        bg: colors.grey.darken3,
      },
    },
  },
  lang: {
    locales: { ar },
    current: "ar",
  },
  icons: {
    iconfont: "fa",
  },
});
